import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import SaberMasButton from "../SaberMasBtn/SaberMasBtn";
import "../SaberMasBtn/SaberMasBtn.css";
import "./Clientes.css";
import panel from "./panel.jpg";
import house from "./house.jpg";
import constr from "./constr.jpg";

const Client = () => {
  return (
    <div className="clientes-page">
      <div className="background-container-clientes"></div>
      
      <Navbar customStyle="client-page" />
    
      {/* Sección de imágenes con texto */}
      <div className="images-main-container">
        {/* Primer proyecto */}
        <div className="image-text-container">
          <img src={panel} alt="Proyecto 1" className="full-width-image" />
          <div className="text-overlay">
            <span className="project-subtitle">NUESTROS PROYECTOS</span>
            <h2>Energía Solar Fotovoltaica</h2>
            <p>Descubra nuestra experiencia en la instalación de sistemas fotovoltaicos. Conozca cómo transformamos cubiertas y terrenos en fuentes de energía limpia y rentable, impulsando un futuro más sostenible.</p>
            <SaberMasButton 
              variant="image-overlay" 
              context="proyecto-paneles" 
            />
          </div>
          <div className="multimedia-btn">
            multimedia CNgroup
          </div>
        </div>

        {/* Segundo proyecto */}
        <div className="image-text-container">
          <img src={house} alt="Proyecto 2" className="full-width-image" />
          <div className="text-overlay">
            <span className="project-subtitle">NUESTROS PROYECTOS</span>
            <h2>Promoción Inmobiliaria</h2>
            <p>Explore nuestros proyectos inmobiliarios que integran la sostenibilidad en cada detalle. Viviendas diseñadas para el confort, la eficiencia energética y el respeto por el medio ambiente.</p>
            <SaberMasButton 
              variant="image-overlay" 
              context="proyecto-inmobiliaria" 
            />
          </div>
          <div className="multimedia-btn">
            multimedia CNgroup
          </div>
        </div>

        {/* Tercer proyecto */}
        <div className="image-text-container">
          <img src={constr} alt="Proyecto 3" className="full-width-image" />
          <div className="text-overlay">
            <span className="project-subtitle">NUESTROS PROYECTOS</span>
            <h2>Obra Civil y Edificación</h2>
            <p>Descubra nuestra pasión por la construcción residencial con soluciones de energía solar y proyectos de construcción civil aplicando nuestra experiencia para construir infraestructuras sostenibles que impulsan el desarrollo de comunidades y empresas comprometidas con el medio ambiente.</p>
            <SaberMasButton 
              variant="image-overlay" 
              context="proyecto-obra-civil" 
            />
          </div>
          <div className="multimedia-btn">
            multimedia CNgroup
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Client;